export default "__VITE_ASSET__409b04ec__"